// extracted by mini-css-extract-plugin
export var addressFields = "_k9-0";
export var animationContainer = "_k9-1";
export var footer = "_k9-2";
export var lineItems = "_k9-3";
export var modalContent = "_k9-4";
export var orderName = "_k9-5";
export var strong = "_k9-6";
export var warning = "_k9-7";